import config from '../config/api';

/**
 * 使用方法
 *
 * cookieUtil.set('name', 'jobs', {hours: 1, domain: '.izhaowo.com'})
 *
 * Vue使用方法：this.cookie.set('name', 'jobs', {hours: 1})
 *
 * **/

let cookieUtil = {
  set: function (name, value, options) {
    let hours = options && options.hours || 24;
    let domain = options && options.domain || '';

    let d = new Date;
    d.setTime(d.getTime() + 60*60*1000*hours);
    if(config.ISDOMAIN || domain){
      window.document.cookie = name + "=" + encodeURIComponent(value) + ";domain=.izhaowo.com;path=/;expires=" + d.toUTCString();
    }else{
      window.document.cookie = name + "=" + encodeURIComponent(value) + ";path=/;expires=" + d.toUTCString();

    }
  },
  get: function (name) {
    let v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? decodeURIComponent(v[2]) : null;
  },
  delete: function (name, options) {
    let op = options || {};
    op.hours = -1;
    this.set(name, '', op);
  },
};


cookieUtil.install = function (Vue, options) {
  Vue.prototype.cookie = {
    set: function (name, value, options) {
      let op = options || {};
      if(config.NODE_ENV === 'production' && config.ISDOMAIN){
        op.domain = '.izhaowo.com';
      }
      cookieUtil.set(name, value, op);
    },

    get: cookieUtil.get,

    delete: function (name, options) {
      let op = options || {};
      if(config.NODE_ENV === 'production' && config.ISDOMAIN){
        op.domain = '.izhaowo.com';
      }
      cookieUtil.delete(name, op);
    },
  };
};

export default cookieUtil;



// WEBPACK FOOTER //
// ./src/plugin/cookie-util.js